import { ErrorMessage } from 'components/ErrorPages/ErrorMessage'

const NotAuthorizedGraphic = () => {
  return (
    <svg
      width="164"
      height="163"
      viewBox="0 0 164 163"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_i_760_962)">
        <path
          d="M7.12061 106.081L82.0006 68.6406L156.881 106.081L82.0006 143.521L7.12061 106.081Z"
          fill="url(#paint0_radial_760_962)"
        />
      </g>
      <path
        d="M156.008 106.08L82.0005 143.084L7.99268 106.08L82.0005 69.0761L156.008 106.08Z"
        stroke="#808076"
        stroke-width="0.78"
      />
      <path
        d="M156.182 81.1201L82.0005 118.211L7.81787 81.1201L82.0005 44.0292L156.182 81.1201Z"
        fill="white"
        stroke="#808076"
        stroke-width="0.624"
      />
      <path
        d="M82.1401 18.4413L157.02 55.8817L157.579 56.161L157.02 56.4393L82.1401 93.8798L82.0005 93.9491L81.8608 93.8798L6.98096 56.4393L6.42334 56.161L6.98096 55.8817L81.8608 18.4413L82.0005 18.3719L82.1401 18.4413Z"
        fill="white"
        stroke="#808076"
        stroke-width="0.624"
      />
      <rect
        x="80.3853"
        y="17.105"
        width="3.744"
        height="3.744"
        fill="#808076"
      />
      <rect
        x="5.50439"
        y="54.5455"
        width="3.744"
        height="3.744"
        fill="#808076"
      />
      <rect
        x="80.3853"
        y="91.9849"
        width="3.744"
        height="3.744"
        fill="#808076"
      />
      <rect
        x="155.264"
        y="54.5455"
        width="3.744"
        height="3.744"
        fill="#808076"
      />
      <path
        d="M57.0408 56.1606L82.0008 43.6806L106.961 56.1606L82.0008 68.6406L57.0408 56.1606Z"
        fill="#F7F7F7"
        stroke="#808076"
        stroke-width="0.624"
      />
      <mask
        id="mask0_760_962"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="56"
        y="43"
        width="52"
        height="26"
      >
        <path
          d="M57.04 56.161L82 43.681L106.96 56.161L82 68.641L57.04 56.161Z"
          fill="#F7F7F7"
          stroke="#808076"
          stroke-width="0.624"
        />
      </mask>
      <g mask="url(#mask0_760_962)">
        <path
          d="M107.115 -1.87018L107.115 160.37"
          stroke="#808076"
          stroke-opacity="0.4"
          stroke-width="0.624"
        />
        <path
          d="M100.875 -1.87018L100.875 160.37"
          stroke="#808076"
          stroke-opacity="0.4"
          stroke-width="0.624"
        />
        <path
          d="M94.6353 -1.87018L94.6352 160.37"
          stroke="#808076"
          stroke-opacity="0.4"
          stroke-width="0.624"
        />
        <path
          d="M88.395 -1.87018L88.395 160.37"
          stroke="#808076"
          stroke-opacity="0.4"
          stroke-width="0.624"
        />
        <path
          d="M82.155 -1.87018L82.155 160.37"
          stroke="#808076"
          stroke-opacity="0.4"
          stroke-width="0.624"
        />
        <path
          d="M75.915 -1.87018L75.915 160.37"
          stroke="#808076"
          stroke-opacity="0.4"
          stroke-width="0.624"
        />
        <path
          d="M69.675 -1.87018L69.675 160.37"
          stroke="#808076"
          stroke-opacity="0.4"
          stroke-width="0.624"
        />
        <path
          d="M63.4351 -1.87018L63.4351 160.37"
          stroke="#808076"
          stroke-opacity="0.4"
          stroke-width="0.624"
        />
        <path
          d="M57.1951 -1.87018L57.1951 160.37"
          stroke="#808076"
          stroke-opacity="0.4"
          stroke-width="0.624"
        />
      </g>
      <defs>
        <filter
          id="filter0_i_760_962"
          x="7.12061"
          y="66.1446"
          width="149.76"
          height="77.376"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-2.496" />
          <feGaussianBlur stdDeviation="4.2744" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_760_962"
          />
        </filter>
        <radialGradient
          id="paint0_radial_760_962"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(82.0006 68.6406) rotate(90) scale(74.88 149.76)"
        >
          <stop offset="0.11088" stop-color="#F2EDE9" />
          <stop offset="0.638841" stop-color="#BAD9F9" />
          <stop offset="1" stop-color="#C0AAD7" />
        </radialGradient>
      </defs>
    </svg>
  )
}

// To be remade as design comes in
export const NotAuthorizedScreen = () => {
  return (
    <ErrorMessage
      canSubmitFeedback={false}
      errorType="notAuthorized"
      graphic={<NotAuthorizedGraphic />}
    />
  )
}
